import type { FileUploadEntity } from '@/shared/entities/FileUploadEntity'
import type { FileUpdateType } from '@/shared/enums/FileUpdateType'

export class CreateUpdateItemGalleryEntity {
  id?: string
  imageUrl?: string
  type?: FileUpdateType
  image?: FileUploadEntity
  order?: number
}
